import React from 'react';
import LegalPage from '../../components/LegalPage';

const ImpressumPage: React.FC = () => (
  <LegalPage contentKey="page_impressum" seoTitleKey="seo.impressum_title" canonicalPath="/impressum" />
);

export default ImpressumPage;
